import { render, staticRenderFns } from "./CrmDataOverview.vue?vue&type=template&id=d8e56738&scoped=true&"
import script from "./CrmDataOverview.vue?vue&type=script&lang=js&"
export * from "./CrmDataOverview.vue?vue&type=script&lang=js&"
import style0 from "./CrmDataOverview.vue?vue&type=style&index=0&id=d8e56738&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8e56738",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDataTable,VPagination,VProgressCircular,VRow})
